import { useState, useEffect } from "react";

export default function Home() {
  const roles = [
    "Web Developer",
    "Frontend Developer",
    "Technical Specialist",

  ];
  const [currentRoleIndex, setCurrentRoleIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentRoleIndex((prevIndex) => (prevIndex + 1) % roles.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [roles.length]);

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white"
    >
      <div className="max-w-4xl mx-auto px-6 py-20 text-center">
        {/* Main Content */}
        <div className="space-y-8">
          {/* Greeting */}
          <div className="space-y-2">
            <p className="text-lg text-gray-600 font-medium">Hello, I'm</p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-gray-900 tracking-tight">
              Beza Mekonnen
            </h1>
          </div>

          {/* Dynamic Role */}
          <div className="h-12 flex items-center justify-center">
            <h2 className="text-2xl md:text-3xl text-blue-600 font-semibold transition-all duration-500 ease-in-out">
              {roles[currentRoleIndex]}
            </h2>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
            I’m a web developer who enjoys creating modern web applications and a technical support professional who helps clients resolve cloud-related issues.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
            <a
              href="#projects"
              className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transform hover:scale-105 transition-all duration-300  hover:shadow-sm"
            >
              View My Work
            </a>
            <a
              href="#contact"
              className="px-8 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-lg hover:border-blue-600 hover:text-blue-600 transition-all duration-300"
            >
              Get In Touch
            </a>
          </div>

          {/* Scroll Indicator */}
          {/* <div className="pt-16 animate-bounce">
            <div className="w-6 h-10 border-2 border-gray-400 rounded-full mx-auto flex justify-center">
              <div className="w-1 h-3 bg-gray-400 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
}
